import { Component, OnInit, Input } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'flowaccount-tech-blog',
  templateUrl: './tech-blog.component.html',
  styleUrls: ['./tech-blog.component.scss'],
})
export class TechBlogComponent implements OnInit {
  @Input() heading = this.translate.currentLang === 'th' ? 'FlowAccount Tech Blog' : 'FlowAccount Tech Blog'
  @Input() readMore = this.translate.currentLang === 'th' ? 'อ่านเพิ่มเติม' : 'Read more'
  @Input() blogList = []

  constructor(public translate: TranslateService) {}

  ngOnInit(): void {}
}
